import { render, staticRenderFns } from "./FailedOrderOverview.vue?vue&type=template&id=3196a397&scoped=true&"
import script from "./FailedOrderOverview.vue?vue&type=script&lang=js&"
export * from "./FailedOrderOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3196a397",
  null
  
)

export default component.exports